import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-form-field-hidden',
    templateUrl: './form-field-hidden.component.html',
    styleUrls: ['./form-field-hidden.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormFieldHiddenComponent implements OnInit{

  @Input() configData: typeDHLFormControls ;
  @Input() frmGroup: UntypedFormGroup ;

  constructor(private appService: AppService) { }

  ngOnInit() {
    const dynamicValue = this.configData['dynamicValue'];
    const format = this.configData['dynamicValueFormat'];
    if ((dynamicValue === 'CURRENT_DATE' || dynamicValue === 'CURRENT_TIME') && format) {
      const now = new Date();
      const pad = (n: number) => n.toString().padStart(2, '0');
      const tokens: { [key: string]: string } = {
        DD:   pad(now.getDate()),
        MM:   pad(now.getMonth() + 1),
        YYYY: now.getFullYear().toString(),
        YY:   now.getFullYear().toString().slice(-2),
        HH:   pad(now.getHours()),
        mm:   pad(now.getMinutes()),
        ss:   pad(now.getSeconds())
      };
      const value = format.replace(/YYYY|YY|DD|MM|HH|mm|ss/g, match => tokens[match]);
      this.frmGroup.get(this.configData.name)?.setValue(value);
    }
    if (this.configData.events) {
      this.onCommonEventHander('CHANGE', null);
    }
  }

  onCommonEventHander(eventType, userEvent) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, userEvent);
        return
      }
    }
  }

  sendToSource(event, data = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    eventData['hidden'] = true;
    console.log("eventData:::",eventData);
    this.appService._commonComponentSubject.next(eventData);
  }

   /** Common Method to check event exist in template */
   checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      // event = (event.length ? event[0] : null);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }

  setValueToControl(value){
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
    }
  }

}
